"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMeterReadsKapiQuery = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var kapi_1 = require("../../../../shared/api/kapi");
function useMeterReadsKapiQuery(options) {
    return (0, ui_tools_1.useApolloQuery)(kapi_1.MeterReadsDocument, options);
}
exports.useMeterReadsKapiQuery = useMeterReadsKapiQuery;
